package com.advaita.cloud.drive.ui.store

/**
 * ADV-1465: the ids from [anchor] to [clicked], both included, in [order] (the rows as the table
 * shows them), added to [selected]. An [anchor] or [clicked] that is not in [order] changes
 * nothing, so a stale anchor never ticks rows off screen.
 *
 * Example: order a..g, anchor a, clicked f: a, b, c, d, e and f are ticked.
 */
internal fun rangeSelect(selected: Set<String>, anchor: String, clicked: String, order: List<String>): Set<String> {
    val from = order.indexOf(anchor)
    val to = order.indexOf(clicked)
    if (from < 0 || to < 0) return selected
    return selected + order.subList(minOf(from, to), maxOf(from, to) + 1)
}
